export default {"src":"/_next/static/media/medal.bb9971e9.svg","height":56,"width":48,"blurWidth":0,"blurHeight":0};